import { render, staticRenderFns } from "./ClientTrips.vue?vue&type=template&id=a3ddc154&"
import script from "./ClientTrips.vue?vue&type=script&lang=js&"
export * from "./ClientTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports